module.exports = __webpack_public_path__ + "assets/img/m22.affd12dd.png";